/* eslint-disable camelcase */
import fetch from '../../api/fetch';
import { REDUX_ACTIONS } from '../../shared/config/constants';
import { MAIN_DEPTH_POINTS } from '../../utils/constants';
import { parseError } from '../../utils/fetchErrorParser';
import { modifyMetricData, modifyMetricDataArray } from '../../utils/getMetrics';
import store from '../store';
import { listHydraulics } from './hydraulics';
import { enqueueSnackbar } from './snackbar';

function generateRandom() {
  const length = 24;
  const charset = 'abcdefghijklmnopqrstuvwxyz0123456789';
  let retVal = '';
  for (let i = 0, n = charset.length; i < length; ++i) {
    retVal += charset.charAt(Math.floor(Math.random() * n));
  }
  return retVal;
}

export const addNewParameterRow = () => (dispatch) => {
  const { hydraulicsParameterAnalysis } = store.getState();
  const newData = [...hydraulicsParameterAnalysis.inputs];
  const existUnit = { ...hydraulicsParameterAnalysis.units };
  const nextId = newData.length - 1;
  const newRow = {
    parameter: '',
    values: ['', ''],
    grid_id: nextId + 1,
    _id: generateRandom(),
    isNewRow: true,
    isDirty: true,
  };

  newData.push(newRow);
  dispatch({
    type: REDUX_ACTIONS.HYDRAULICS_PARAMETER_ANALYSIS_LIST_SUCCESS,
    payload: {
      data: [...hydraulicsParameterAnalysis.data],
      inputs: newData,
      units: existUnit,
      paginatedElements: newData.length,
    },
  });
};

export const listHydraulicsParameter = (payload) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.HYDRAULICS_PARAMETER_ANALYSIS_LIST_LOADING,
  });
  const body = {
    query: {
      wellsInfoId: payload.wellsInfoId,
      runId: payload.runId
    }
  };
  return fetch
    .post('hydraulicsParametric/fetch', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then((data) => {
      const { currentUser } = store.getState();
      const currentUnit = currentUser?.preferences?.unitSystem;
      const { data: hydraulicParameter = [], units = {} } = data || [];

      const payload = {
        ...data,
        inputs: [],
        data: [],
        paginatedElements: 0,
        units: data?.units || {}
      };

      if (hydraulicParameter.length > 0) {
        const transformedData = {
          inputs: hydraulicParameter.map(item => ({
            [item.parameter]: { _id: item._id, values: item.values }
          }))
        };
        const formattedData = {
          ...transformedData,
          inputs: transformedData.inputs.map(inputObj => {
            const key = Object.keys(inputObj)[0];
            const { _id, values } = inputObj[key];
            const convertedValues = modifyMetricDataArray([{ [key]: values }], units?.inputs, currentUnit)[0][key] || values;

            return {
              _id,
              parameter: key,
              values: convertedValues
            };
          })
        };
        payload.inputs = formattedData.inputs;
        payload.data = [formattedData];
        payload.paginatedElements = formattedData.inputs.length;
      }
      dispatch({
        type: REDUX_ACTIONS.HYDRAULICS_PARAMETER_ANALYSIS_LIST_SUCCESS,
        payload
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.HYDRAULICS_PARAMETER_ANALYSIS_LIST_ERROR,
        payload: { ...error, message: 'Error' },
      });
    });
};

export const createHydraulicParameter = (payload, hydraulicsBody) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.HYDRAULICS_PARAMETER_ANALYSIS_LIST_LOADING,
  });
  const { query, isParametricResults } = hydraulicsBody;
  const body = {
    query: {
      wellsInfoId: payload.wellsInfoId,
      runId: payload.runId,
    },
    input: payload.input
  };
  return fetch
    .post('hydraulicsParametric/create', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch(
        enqueueSnackbar(
          'Hydraulic Parameter Created Successfully.',
          'success',
          new Date().getTime() + Math.random()
        ));
      dispatch(listHydraulicsParameter(payload));
      if (isParametricResults) {
        dispatch(listHydraulics(query));
      }
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
    });
};

export const updateHydraulicParameter = (payload, hydraulicsBody) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.HYDRAULICS_PARAMETER_ANALYSIS_LIST_LOADING,
  });
  const { query, isParametricResults } = hydraulicsBody;
  const body = {
    query: {
      wellsInfoId: payload.wellsInfoId,
      runId: payload.runId,
      _id: payload._id
    },
    input: payload.input
  };
  return fetch
    .put('hydraulicsParametric', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch(
        enqueueSnackbar(
          'Hydraulic Parameter Updated Successfully.',
          'success',
          new Date().getTime() + Math.random()
        ));
      dispatch(listHydraulicsParameter(payload));
      if (isParametricResults) {
        dispatch(listHydraulics(query));
      }
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
    });
};

export const deleteHydraulicParameter = (payload, hydraulicsBody) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.HYDRAULICS_PARAMETER_ANALYSIS_LIST_LOADING,
  });
  const { query, isParametricResults } = hydraulicsBody;
  const body = {
    query: {
      wellsInfoId: payload.wellsInfoId,
      runId: payload.runId,
      _id: payload._id
    },
  };
  return fetch
    .deleteAction('hydraulicsParametric', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch(
        enqueueSnackbar(
          'Hydraulic Parameter Deleted Successfully',
          'success',
          new Date().getTime() + Math.random()
        ));
      dispatch(listHydraulicsParameter(payload));
      if (isParametricResults) {
        dispatch(listHydraulics(query));
      }
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
    });
};

export const runParametricAnalysis = (body, disableLoader, onClose) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.HYDRAULICS_LIST_LOADING,
  });
  dispatch({
    type: REDUX_ACTIONS.HYDRAULICS_PARAMETER_ANALYSIS_LIST_LOADING,
  });
  const { runId, query } = body;
  const input = {
    input: {
      url: `/runs/parametric/${runId}`,
      method: 'POST',
    }
  };
  return fetch
    .post('premiumHydraulics/proxy', input)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch(
        enqueueSnackbar(
          'Parametric Analysis Simulation Completed Successfully.',
          'success',
          new Date().getTime() + Math.random()
        ));
      disableLoader();
      onClose();
      dispatch({
        type: REDUX_ACTIONS.HYDRAULICS_PARAMETER_ANALYSIS_SET_FALSE,
      });

      dispatch(listHydraulics(query));
    })
    .catch(async (error) => {
      disableLoader();
      dispatch({
        type: REDUX_ACTIONS.HYDRAULICS_PARAMETER_ANALYSIS_SET_FALSE,
      });

      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
      dispatch(listHydraulics(query));
    });
};

export const listParametricAnalysisResults = (payload) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.HYDRAULICS_PARAMETER_ANALYSIS_DATA_LIST_LOADING,
  });
  const body = {
    query: {
      wellsInfoId: payload.wellsInfoId,
      runId: payload.runId,
    }
  };
  return fetch
    .post('hydraulicsParametric/results/fetch', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then((data) => {
      const { currentUser } = store.getState();
      const currentUnit = currentUser?.preferences?.unitSystem;
      const { data: hydraulicsData, units } = data;

      const transformedData = {
        inputs: hydraulicsData.inputs.map(item => ({
          [item.parameter]: { _id: item._id, values: item.values }
        }))
      };

      const formattedData = transformedData.inputs.map(inputObj => {
        const key = Object.keys(inputObj)[0];
        const { _id, values } = inputObj[key];
        const convertedValues = modifyMetricDataArray([{ [key]: values }], units?.inputs, currentUnit)[0][key] || values;

        return {
          _id,
          parameter: key,
          values: convertedValues
        };
      });
      const targetData_anchorPoint = hydraulicsData?.run_details_copy?.target_data?.anchor_point;
      const listData = hydraulicsData.results.map((item) => {
        const { casing_shoe, hole_depth, landing_point, surface } = item.depths_summary || {};
        let modifiedObservation = {};
        const rawInputs = { ...item.inputs };
        if (rawInputs?.pumping_mw !== undefined) {
          rawInputs.mw = rawInputs.pumping_mw;
          delete rawInputs.pumping_mw;
        }
        const modifiedInputs = modifyMetricData([rawInputs], units?.inputs, currentUnit)[0];
        const modifiedSummary = modifyMetricData([item.summary], units?.summary, currentUnit)[0];
        const modifiedCasingShoe = modifyMetricData([casing_shoe], units?.depths_summary?.casing_shoe, currentUnit)[0];
        const modifiedHoleDepth = modifyMetricData([hole_depth], units?.depths_summary?.hole_depth, currentUnit)[0];
        const modifiedLandingPoint = modifyMetricData([landing_point], units?.depths_summary?.landing_point, currentUnit)[0];
        const modifiedSurface = modifyMetricData([surface], units?.depths_summary?.surface, currentUnit)[0];
        const modifiedDepthPoints = modifyMetricData(item.depth_points, units?.depth_points, currentUnit);
        const isCustomAnchorPoint = targetData_anchorPoint && !MAIN_DEPTH_POINTS.includes(targetData_anchorPoint);
        if (isCustomAnchorPoint) {
          modifiedObservation = modifyMetricData(
            [item.depths_summary[targetData_anchorPoint.replace(/ /g, '_')?.toLowerCase()]],
            units?.depths_summary?.casing_shoe,
            currentUnit
          )[0];
        }

        return {
          ...item,
          inputs: modifiedInputs,
          depth_points: modifiedDepthPoints,
          summary: modifiedSummary,
          depths_summary: {
            casing_shoe: modifiedCasingShoe,
            hole_depth: modifiedHoleDepth,
            landing_point: modifiedLandingPoint,
            surface: modifiedSurface,
            ...(targetData_anchorPoint !== undefined && isCustomAnchorPoint && {
              [targetData_anchorPoint.replace(/ /g, '_')?.toLowerCase()]: modifiedObservation
            })
          }
        };
      });

      dispatch({
        type: REDUX_ACTIONS.HYDRAULICS_PARAMETER_ANALYSIS_DATA_LIST_SUCCESS,
        payload: {
          run_details_copy: hydraulicsData?.run_details_copy,
          results: listData,
          inputs: formattedData,
          paginatedElements: listData.length,
          units: data.units
        },
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.HYDRAULICS_PARAMETER_ANALYSIS_DATA_LIST_ERROR,
        payload: { ...error, message: 'Error' },
      });
    });
};
